import { createFileRoute } from "@tanstack/react-router";
import SaintFortLauderdalePage from "@/pages/learn/SaintFortLauderdalePage";
export const Route = createFileRoute("/locations/saint-tms-fort-lauderdale")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® TMS Near Fort Lauderdale | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "SAINT® TMS near Fort Lauderdale: 5-day fMRI-guided depression treatment at Neuro Wellness in Coral Springs, FL. Free consultation and benefits verification.",
        },
        {
          property: "og:title",
          content: "SAINT® TMS Near Fort Lauderdale | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "SAINT® TMS near Fort Lauderdale: 5-day fMRI-guided depression treatment at Neuro Wellness in Coral Springs, FL. Free consultation and benefits verification.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/locations/saint-tms-fort-lauderdale",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/locations/saint-tms-fort-lauderdale",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintFortLauderdalePage />;
}
